import { execute, gql, type ResultOf, type VariablesOf } from './financial-bff-gql'

export const COMMISSIONING_RESET_CUSTOMER_REJECTION = gql(`
  mutation CommissioningResetCustomerRejection($project_id: ID!) {
    installation_commissioning_reset_customer_rejection(project_id: $project_id) {
      success
      message
      data {
        project_id
        installation_id
        removed_monitorings
        removed_inverters
        code
      }
    }
  }
`)

export type CommissioningResetCustomerRejectionVariables = VariablesOf<typeof COMMISSIONING_RESET_CUSTOMER_REJECTION>
export type CommissioningResetCustomerRejectionResult = ResultOf<typeof COMMISSIONING_RESET_CUSTOMER_REJECTION>
export type CommissioningResetCustomerRejectionPayload = NonNullable<
  CommissioningResetCustomerRejectionResult['installation_commissioning_reset_customer_rejection']
>

export async function fetchCommissioningResetCustomerRejection(
  variables: CommissioningResetCustomerRejectionVariables,
) {
  const data = await execute(COMMISSIONING_RESET_CUSTOMER_REJECTION, variables)
  return data.installation_commissioning_reset_customer_rejection
}
